define('rest/utils',[], function() {
    'use strict';

    return {
        or: function(value, defaultValue) {
            return value || defaultValue;
        },

        required: function(value, error) {
            if (value === undefined) {
                throw new TypeError(error);
            }
            return value;
        },

        extractQueryParams: function(options, queryParams, queryParamNames) {
            var option;
            for (option in options) {
                if (options.hasOwnProperty(option) && queryParamNames.indexOf(option) > -1) {
                    queryParams[option] = options[option];
                }
            }
        }
    };
});

